/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Settings_Sub_Credits_ParallelInputs */

const en_settings_sub_credits_parallel = /** @type {(inputs: Settings_Sub_Credits_ParallelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.n} concurrent agents active`)
};

const id_settings_sub_credits_parallel = /** @type {(inputs: Settings_Sub_Credits_ParallelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.n} agent bersamaan aktif`)
};

/**
* | output |
* | --- |
* | "+{n} concurrent agents active" |
*
* @param {Settings_Sub_Credits_ParallelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_sub_credits_parallel = /** @type {((inputs: Settings_Sub_Credits_ParallelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Sub_Credits_ParallelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_sub_credits_parallel(inputs)
	return en_settings_sub_credits_parallel(inputs)
});